module.exports = __webpack_public_path__ + "static/widgets_2-91c6bfe2b7fc4acb1ce2937edc9f938e.png";